import React, { useContext, useState, useEffect } from "react";
import DriverPublicHeader from "../../components/app-header/driver-public-header";
import Footer from "../../components/app-footer/Footer";
import { Col, Container, Row } from "react-bootstrap";
import BankingDocumentationForm from "../../components/banking-documentation/BankingDocumentationForm";
import DriverProfileModal from "../../components/profile-modal/DriverProfileModal";
import { IoMdSettings } from "react-icons/io";
import { DriverSidebar } from "../../App";
import FooterNew from "../../components/app-footer/FooterNew";
import NewDriverHeader from "../../components/app-header/NewDriverHeader";

const BankingDocumentationPage = () => {
    const [showDriverSidebar, setShowDriverSidebar] = useContext(DriverSidebar);

    const handleDriverSidebar = () => {
        setShowDriverSidebar(true)
        document.body.classList.add("handleProfilemodal");
    }

    return (
        <>
            <NewDriverHeader/>
            <div className="banking-documentation setup-profile">
                <div className="d-flex">
                    <div className="left">
                        {
                            showDriverSidebar === true &&
                            <DriverProfileModal />
                        }
                    </div>

                    <div className="right w-100 px-2 px-md-0 py-5">
                        <Row>
                            <Col className="d-block d-md-none" xs={12}>
                                <div className="text-end me-3">
                                    <IoMdSettings onClick={() => handleDriverSidebar(true)} className="text-white icon-setting" />
                                    {
                                        showDriverSidebar == false &&
                                        <hr />
                                    }
                                </div>
                            </Col>

                            <Col xs={12} md={{span:12, offset:1}} className="mb-2">
                                <h1>Banking documentation</h1>
                            </Col>

                            <Col xs={12} md={{span:12, offset:1}} className="mb-3">
                                <p>Please print and complete All the information below</p>
                            </Col>

                            <Col xs={12} xxl={{ span: 4, offset: 1 }} xl={{ span: 5, offset: 1 }} lg={{ span: 6, offset: 1 }} md={{ span: 9, offset: 1 }}>
                                <BankingDocumentationForm />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            <FooterNew />
        </>
    )
}

export default BankingDocumentationPage